import React, { useRef, useState } from 'react';
import { noop } from 'lodash';
import { object } from 'prop-types';
import classNames from 'classnames';
import { getContext, I18n } from '@fiverr-private/fiverr_context';
import { metric } from '@fiverr-private/perseus';
import { Button } from '@fiverr-private/fit';
import { JS_JOIN_HOOK } from '../../../../../../utils/constants';
import { MP_LIMITED_EDITION_APPLY } from '../../../../../../utils/mixPanelEvents';

// eslint-disable-next-line no-empty-pattern
const LimitedEdition = ({ }, { limitedEdition, biEvents }) => {
    const modalRef = useRef(null);
    const [modalImported, setModalImported] = useState(false);
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(limitedEdition.submitted);

    const { userId } = getContext();
    const isLoggedIn = !!userId;
    const classes = classNames({ [JS_JOIN_HOOK]: !isLoggedIn });
    const ctaSuffix = submitted ? 'entry_submitted' : 'submit_your_entry';
    let closeModal = noop;
    let openModal = noop;

    const onClick = async(e) => {
        e.preventDefault(); // to prevent the form from being submitted

        biEvents.sendMixPanelEvent({ eventName: MP_LIMITED_EDITION_APPLY });
        metric.count(`limited_edition.apply.click.logged_in.${isLoggedIn}`);

        if (!isLoggedIn) {
            return;
        }

        if (!modalImported) {
            setLoading(true);
            const modal = await import(/* webpackChunkName: 'LimitedEditionModal' */'../../../../../LimitedEdition/Modal');
            modalRef.current = modal.default;
            setLoading(false);
            setModalImported(true);
        } else {
            openModal();
        }
    };

    const setModalTriggers = ({ open, close }) => {
        openModal = open;
        closeModal = close;
    };

    const onSubmit = () => {
        setSubmitted(true);
        closeModal();
    };

    return (
        <>
            <Button className={classes}
                loading={loading}
                disabled={submitted}
                onClick={onClick}>
                <I18n k={`gig_page_perseus.limited_edition.cta.${ctaSuffix}`}/>
            </Button>
            {modalImported && <modalRef.current trigger={setModalTriggers} onSubmitSuccess={onSubmit} limitedEdition={limitedEdition}/>}
        </>

    );
};

LimitedEdition.contextTypes = {
    limitedEdition: object,
    biEvents: object
};

export default LimitedEdition;
